module.exports = __webpack_public_path__ + "img/shared-3.01a4a28e.jpg";